(() => {
  'use strict';

  function compactProperties(properties = {}) {
    // Only migrate our configurator's old properties; keep gifts and other apps intact.
    if (!(properties.Design || properties._Design) || !(properties.Garment || properties._Garment) || !properties['Print side']) return null;
    const next = { ...properties };
    let changed = false;
    for (const key of ['Design', 'Garment', 'Garment color']) {
      if (!Object.prototype.hasOwnProperty.call(next, key)) continue;
      next[`_${key}`] = next[key];
      delete next[key];
      changed = true;
    }
    return changed ? next : null;
  }

  async function migrateCart(cart, change) {
    const quantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);
    const limit = cart.items.length;
    for (let index = 0; index < limit; index++) {
      const item = cart.items.find(line => compactProperties(line.properties));
      if (!item) return cart;
      // Properties change line keys and can merge identical lines. Always use
      // the latest cart response, never an earlier array index or stale key.
      cart = await change({ id: item.key, quantity: item.quantity, properties: compactProperties(item.properties) });
      if (cart.items.reduce((sum, line) => sum + line.quantity, 0) !== quantity) throw new Error('Unexpected cart quantity change');
    }
    if (cart.items.some(item => compactProperties(item.properties))) throw new Error('Cart details update incomplete');
    return cart;
  }

  window.apexCartDetails = { compactProperties, migrateCart };
})();
